import { render, staticRenderFns } from "./TermTeachingPlans.vue?vue&type=template&id=98948058"
import script from "./TermTeachingPlans.vue?vue&type=script&lang=js"
export * from "./TermTeachingPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports